export default class ArticleMetrics {
    constructor() {
        this.tab = document.querySelectorAll('.metrics-tabs__item-link');
        this.init();
    }
    init() {
        this.tab.forEach(element => {
            element?.addEventListener('click', this.handleTabChange);
        });
    }
    handleTabChange() {
        const navItem = document.querySelector('.metrics-nav__item-link:not(.metrics-selected--js) span');
        navItem?.click();
    }
}
